import { useQuery } from '@apollo/client';
import type { UseLalSegmentsWithDetails } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { GetLalSegmentsWithDetailsDocument } from '../../../graphql/query/segments/lal/GetLalSegmentsWithDetails.generated';

export const useLalSegmentsWithDetails: UseLalSegmentsWithDetails = ({ segmentIds }) => {
  const { loading, data: { lookalike_definitions = [] } = {} } = useQuery(GetLalSegmentsWithDetailsDocument, {
    variables: {
      segmentIds,
    },
  });

  return {
    loading,
    lalSegments: lookalike_definitions,
  };
};
